import React from 'react'

const ExternalLink = props => {
    const { href, children, openNewTab, ...rest } = props
    delete rest.navigate
    const linkProps = openNewTab
        ? { target: '_blank', rel: 'noopener noreferrer', ...rest }
        : rest

    return (
        <a href={href} {...linkProps}>
            {children}
        </a>
    )
}

export default ExternalLink
